import React from 'react';
import { useNavigate } from 'react-router-dom';

import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Typography } from '@mui/material';

import PrimaryLayout from '../components/layout/PrimaryLayout';
// import { model_dummy_data } from '../views/models/dummy_data';

const Models: React.FC = () => {
    const navigate = useNavigate();
    // useEffect(() => {
    //     mlflowService.fetchModels();
    //   }, []);
    return (
        <PrimaryLayout>
            <Box display='flex' justifyContent='space-between' alignItems='center'>
                <Typography sx={{ m: 2 }} variant='h4'>Models</Typography>
                <Button variant='contained' sx={{ m: 2 }} startIcon={<AddIcon />} onClick={() => navigate("add-model")}>
                    Add Model
                </Button>
            </Box>
        </PrimaryLayout>
    );
}

export default Models;
